/**
 * Pantalla "Calificaciones Escolar" (módulo Control Escolar)
 *
 * Versión expandida de Registro de Calificaciones SIN restricción por
 * asesor: cualquier usuario con acceso al módulo Control Escolar ve
 * TODOS los grupos del campus seleccionado y puede capturar
 * calificaciones (UPSERT) de cualquier grupo.
 *
 * Reglas clave:
 *  - Filtro global de campus (HeaderGlobal) sigue funcionando.
 *  - Filtro adicional de Sección Académica arriba de la tabla.
 *  - Tabla de captura muestra TODAS las columnas (P1, P2, P3, Final, Extraordinario)
 *    en una sola vista (sin selector de tipo de evaluación).
 *  - Persistencia en la MISMA tabla esc_calificaciones; si existe el
 *    par (id_estudiante_grupo, tipo_evaluacion) -> UPDATE; si no -> INSERT.
 *  - Reutiliza estilos y modal de reporte de RegistroCalificacionesScreen.
 */

import React, { useState } from 'react';
import styles from '../../styles/CampusStyles/PantallaDeCampus.module.css';
import Sidebar from '../../components/Sidebar';
import HeaderGlobal from '../../components/HeaderGlobal';
import BusquedaGrupoCampus from './BusquedaGrupoCampus';
import RegistroGrupoMulti from './RegistroGrupoMulti';
import ReporteCalificacionesModal from '../RegistroCalificacionesScreen/ReporteCalificacionesModal';

function CalificacionesEscolarScreen() {
  const [vistaActual, setVistaActual] = useState('busqueda'); // 'busqueda' | 'registro'
  const [grupoSeleccionado, setGrupoSeleccionado] = useState(null);
  const [campusSeleccionado, setCampusSeleccionado] = useState('');
  const [mostrarReporte, setMostrarReporte] = useState(false);
  const [estudiantesReporte, setEstudiantesReporte] = useState([]);

  const handleSeleccionarGrupo = (grupo) => {
    setGrupoSeleccionado(grupo);
    setVistaActual('registro');
  };

  const handleRegresar = () => {
    setVistaActual('busqueda');
    setGrupoSeleccionado(null);
  };

  const handleAbrirReporte = (estudiantes) => {
    setEstudiantesReporte(estudiantes);
    setMostrarReporte(true);
  };

  const handleCerrarReporte = () => setMostrarReporte(false);

  return (
    <main className={styles.campusScreen}>
      <div className={styles.mainLayout}>
        <aside className={styles.sidebarColumn}>
          <Sidebar />
        </aside>

        <div className={styles.contentColumn}>
          <div className={styles.contentWrapper}>
            <HeaderGlobal
              title="Calificaciones Escolar"
              onCampusChange={(campusId) => setCampusSeleccionado(campusId)}
            />

            <section className={styles.mainContent}>
              <div className={styles.tableSection}>
                {vistaActual === 'busqueda' ? (
                  <BusquedaGrupoCampus
                    campusSeleccionado={campusSeleccionado}
                    onSeleccionarGrupo={handleSeleccionarGrupo}
                  />
                ) : (
                  <RegistroGrupoMulti
                    grupo={grupoSeleccionado}
                    onRegresar={handleRegresar}
                    onAbrirReporte={handleAbrirReporte}
                  />
                )}
              </div>
            </section>

            {mostrarReporte && (
              <ReporteCalificacionesModal
                grupo={grupoSeleccionado}
                estudiantes={estudiantesReporte}
                onCerrar={handleCerrarReporte}
              />
            )}
          </div>
        </div>
      </div>
    </main>
  );
}

export default CalificacionesEscolarScreen;
